import { Bell, LogOut, UserRound } from "lucide-react";
import { Link, Outlet } from "react-router-dom";

import ivoryHealthLogo from "@/assets/ivory-health-logo.webp";
import { useAuth } from "@/context/AuthContext";
import { useTenant } from "@/context/TenantContext";
import { getTenantLogo } from "@/lib/tenantLogos";

import { BottomNavigation } from "./BottomNavigation";

export function PortalShell() {
  const { user, signOut } = useAuth();
  const { name: tenantName, client_id: clientId, logo_url: logoUrl } = useTenant();
  const tenantLogo = getTenantLogo(clientId) || logoUrl;

  return (
    <div className="portal-shell" data-testid="employee-portal" data-tenant={clientId}>
      <header className="portal-header" data-testid="portal-header">
        <div className="brand-lockup" data-testid="portal-brand">
          {tenantLogo ? <img src={tenantLogo} alt={tenantName} className="brand-lockup__logo" data-testid="tenant-logo" /> : <span className="brand-lockup__mark">{tenantName.charAt(0)}</span>}
          <div>
            <strong>{tenantName}</strong>
            <span>Health Hub</span>
          </div>
        </div>
        <div className="header-profile">
          <Link to="/profile" className="header-profile__name" data-testid="employee-name">{user?.name || "Employee"}</Link>
          <Link to="/profile" className="icon-button" aria-label="Your profile" data-testid="profile-link"><UserRound aria-hidden="true" size={19} /></Link>
          <Link to="/updates" className="icon-button" aria-label="Care updates" data-testid="care-updates-link"><Bell aria-hidden="true" size={19} /></Link>
          <button className="icon-button" type="button" onClick={signOut} aria-label="Sign out" data-testid="sign-out-button">
            <LogOut aria-hidden="true" size={19} />
          </button>
        </div>
      </header>
      <main className="portal-content">
        <Outlet />
        <footer className="powered-by-footer" data-testid="powered-by-footer">
          <span>Powered by</span>
          <img src={ivoryHealthLogo} alt="Ivory Health" data-testid="ivory-health-logo" />
        </footer>
      </main>
      <BottomNavigation />
    </div>
  );
}